import { useEffect, useState } from 'react';
import DocViewer from '../shared/components/DocViewer';
import './DocuMateRecycleBin.scss';
import { toast } from 'react-toastify';
import Logger from '../../shared/services/Logger';
import DocuMateScanService from '../DocuMateScan/DocuMateScanService';
import * as constant from '../../shared/util/constant';
import { useHistory, useLocation } from 'react-router-dom';
import DocuMateIndexingService from './DocuMateIndexingService';
import { Column, Panel, Row, TextInput } from '../../components';
import { ErrorBoundary } from 'react-error-boundary'
import { FallbackComponent } from '../../shared/components/FallbackComponent';
import { Button as ReactButton } from 'primereact/button';
import { Form, FloatingLabel } from 'react-bootstrap';
import moment from 'moment';
import * as docuMateConstant from '../shared/util/docuMateConstant';
import * as documateLabel from '../shared/util/docuMateLabel';
import DocHistoryModel from '../model/DocHistoryModel';
import { ConfirmModal } from '../../shared/components/confirmModal';
import DocuMateRecycleBinService from './DocuMateRecycleBinService';

interface DocuMateRecycleBinProps {
    id?: string;
    scanId?: string;
}

const DocuMateRecycleBin: React.FC<DocuMateRecycleBinProps> = (props) => {
    const history = useHistory();
    const location = useLocation();
    const state = location.state as { scanId: string, id: string, docStatus: string };   
    const urlParam = new URLSearchParams(location.search)
    const [scanId, setScanId] = useState(state?.scanId);
    const [queuedDocId, setQueuedDocId] = useState(state?.id || urlParam.get('id'));
    const [docNameAPI, setDocNameAPI] = useState('');
    const [docPdf, setDocPDf] = useState<any>(null);
    const documateServiceObj = new DocuMateScanService();
    const docuMateIndexingServiceObj =new DocuMateIndexingService();
    const documateRecycleBinServiceObj = new DocuMateRecycleBinService();
    const [newNote, setNewNote] = useState('');
    const [noteError, setNoteError] = useState(false);
    const [docHistory, setDocHistory] = useState<DocHistoryModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [modalBody, setModalBody] = useState(null);
    const [indexGroupId, setIndexGroupId] = useState('');
    const [indexFolderid, setIndexFolderid] = useState('');

     useEffect(() => {           
            DocFetailsById(queuedDocId);  
            setQueuedDocId(queuedDocId); 
            DomainEventNotes();       
        }, []);

         const DocFetailsById = async (queuedDocId: string) => {
                const data = await docuMateIndexingServiceObj.GetDocumentFileDetailsById(queuedDocId);    
                 setIndexGroupId(data.groupId);
                 setIndexFolderid(data.folderId);           
                 FetchDocument(data.docFileId);
            }
        
    const FetchDocument = async (docFileId: string) => {
        try {
            let documentResponse = await documateServiceObj.getDocument(docFileId);
            setDocNameAPI(scanId);
            setDocPDf(documentResponse.blob);
        }
        catch (error) {
            setDocNameAPI('');
            setDocPDf(null);
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

     const DomainEventNotes = async () => {
            setLoading(true)
            try {
                const data = await docuMateIndexingServiceObj.GetDocHistory(queuedDocId);
                let modifiedData = data.map(item => ({
                    ...item,
                    combinedKey: `${item.changedBy}-${item.changedDate}`
                }));
                setDocHistory(modifiedData)
            }
            catch (error) {
                Logger.logError(error.toString());
                toast.error("Failed to Load notes.");
            }
            setLoading(false);
        }

    const modalSuccess = async () => {
                setShowConfirmModal(false); // Close the modal                  
                try {                    
                        if(docPdf !== null)
                        {
                            let resRestored = await documateRecycleBinServiceObj.restoreDocument(queuedDocId);
                            
                            if (resRestored != null && resRestored.isRestored) {
                                if (indexFolderid === docuMateConstant.RescanFolderId) {
                                    history.push({
                                        pathname: `/documate-scan`,
                                        state: {}
                                    });
                                }
                                else {
                                    history.push({
                                        pathname: `/documate-indexing`,
                                        state: { groupIdFromIndexing: indexGroupId, folderIdFromIndexing: indexFolderid }
                                    });
                                }
                            }
                            else{
                                toast.error(docuMateConstant.Restore_Error_Message, {
                                    position: toast.POSITION.TOP_RIGHT,
                                    autoClose: constant.AUTO_CLOSE
                                });
                            }
                  }
                } catch (error) {
                    toast.error(docuMateConstant.Restore_Error_Message, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: constant.AUTO_CLOSE
                    });
    
                    Logger.logError(error.toString());
                }
    }

    const handleClose = () => {
        history.push({
            pathname: `/documate-recycle-bin`,
            state: { groupIdFromIndexing: indexGroupId, folderIdFromIndexing: indexFolderid }
        });
    }

    const handleRestore = async () => {
        if(docPdf !== null)
         {
            setModalBody(
                <>
                    <p>Are you sure you want to Restore <strong>{scanId}</strong> and remove it from the Recycle Bin?</p>
                </>
            );
            setShowConfirmModal(true);
       }
            
    }

    const handleAddNote = async () => {
            if (!newNote || newNote.trim() === "") {
                setNoteError(true);
                toast.warn("Please enter a note before submitting.");
                return;
            }
            setNoteError(false);
            try {
                const data = await docuMateIndexingServiceObj.AddDocNotes(queuedDocId, newNote);
                toast.success("Note added successfully!");
                setNewNote(""); // Clear the input after success
    
                let modifiedData = data.map(item => ({
                    ...item,
                    combinedKey: `${item.changedBy}-${item.changedDate}`
                }));
                setDocHistory(modifiedData)
            } catch (error) {
                Logger.logError(error.toString());
                toast.error("Failed to add note.");
            }
        };

     const renderNotes = (docHistory) => {
        const customOrderDefault = ['QueueId', 'AssignedTo', 'LastRedirectedReason', 'LastRedirectedNote'];
        const customOrderMR = ['AssignedTo', 'LastRedirectedNote', 'QueueId', 'LastRedirectedReason',];

        const groupedData = docHistory.reduce((acc, item) => {
            const formattedTime = moment(item.changedDate).format('MM/DD/YYYY hh:mm A');

            if (!acc[formattedTime]) {
                acc[formattedTime] = [];
            }

            acc[formattedTime].push(item);

            acc[formattedTime].sort((a, b) => {
                const order = a.eventType === 'RedirectMR' ? customOrderMR : customOrderDefault;
                const indexA = order.indexOf(a.fieldName);
                const indexB = order.indexOf(b.fieldName);
                return indexA - indexB;
            });

            return acc;
        }, {});

        return (
            <div className="redirectnotepanel-recycle-bin">
                <ErrorBoundary FallbackComponent={FallbackComponent}>
                    {loading ? (
                        <span>Loading...</span>
                    ) : Object.keys(groupedData).length > 0 ? (
                        Object.entries(groupedData).map(([formattedTime, group]: [string, DocHistoryModel[]], groupIndex) => (
                            <div key={groupIndex} className="note-item">
                                <div className="note-header">
                                    <Row>
                                        <Column lg={12}>
                                            <span className="note-content">
                                                {group.map((history, hIndex) => (
                                                    <span key={hIndex}>
                                                        {history.eventType === "RedirectMR" ?
                                                            (
                                                                <span>

                                                                    {history.fieldName === "AssignedTo" && (
                                                                        <>
                                                                            <strong>Review: </strong>{history.changedBy} at <strong className='align-right'>{formattedTime}</strong>
                                                                            <br />
                                                                            <strong>Assigned: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {history.fieldName === "LastRedirectedNote" && (
                                                                        <>
                                                                            <strong>Redirect Note: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {history.fieldName === "QueueId" && (
                                                                        <>
                                                                            <strong>Documemt Returned: </strong>{history.newValue}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                </span>
                                                            )
                                                            :
                                                            history.eventType === "Redirect Document" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "QueueId" && (
                                                                            <>
                                                                                By <strong>{history.changedBy}</strong> at <strong className='align-right'>{formattedTime} </strong>
                                                                                <br />
                                                                                <strong>Document Redirected: </strong>{history.oldValue} folder to {history.newValue} folder
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "AssignedTo" && (
                                                                            <>
                                                                                <span> to {history.newValue} </span>
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "LastRedirectedReason" && (
                                                                            <>
                                                                                <br />
                                                                                <strong>Redirect Reason: </strong>{history.newValue}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                        {history.fieldName === "LastRedirectedNote" && (
                                                                            <>
                                                                                <strong>Redirect Note: </strong>{history.newValue}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                )
                                                                :
                                                                history.eventType === "Document Scanned" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "DocumentScanned" && (
                                                                                    <>
                                                                                        <span>Scanned By <strong className="username">{history.changedBy}</strong>on <strong className='align-right'>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong> </span>
                                                                                        <br />
                                                                                    </>
                                                                        )}
                                                                    </span>
                                                                )
                                                                :
                                                                history.eventType === "Document Emailed" ?
                                                                (
                                                                    <span>
                                                                        {history.fieldName === "IsFromEmail" && (
                                                                                    <>
                                                                                        <span>Received in email inbox on <strong className='align-right'>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong></span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                    </span>
                                                                )
                                                                :
                                                                (
                                                                    <span key={hIndex}>
                                                                        <Row>
                                                                            <Column lg={6}>
                                                                                <strong className="username">{history.changedBy}</strong>
                                                                                <span className="timestamp">{history.eventType}</span>
                                                                            </Column>
                                                                            <Column lg={6} style={{ textAlign: "right" }}>
                                                                                <span>
                                                                                    <strong>{moment(history.changedDate).format('MM/DD/YYYY hh:mm A')}</strong>
                                                                                </span>
                                                                            </Column>
                                                                            <Column lg={8}>
                                                                                {history.fieldName === "OnHold" && (
                                                                                    <>
                                                                                        <span>Document Status changed to {history.newValue}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}                                                                                
                                                                                {history.fieldName === "LatestNotes" && (
                                                                                    <>
                                                                                        <span className="note-content">{history.newValue}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                            </Column>
                                                                        </Row>
                                                                    </span>
                                                                )}
                                                    </span>
                                                ))}
                                            </span>
                                        </Column>
                                    </Row>
                                </div>
                                <br />
                            </div>
                        ))) : (
                        <div>No Notes/Events found</div>
                    )}
                </ErrorBoundary>
            </div>
        );
    };

    return (
     <div className="documate-recycle-bin">
        <Row>
            <div className="restore-button-container">
                    <ReactButton
                                    className="btn btn-primary"
                                    onClick={handleClose}
                                    style={{width:'100px',marginRight:'10px'}}
                                >
                                    {documateLabel.DOCUMATE_RECYCLE_BIN_CLOSE}
                                </ReactButton>
                    <ReactButton
                                    className="btn btn-primary"                                  
                                    onClick={handleRestore}   
                                    style={{width:'100px;',marginRight:'50px'}}                                 
                                >
                                    {documateLabel.DOCUMATE_RECYCLE_BIN_RESTORE}
                                </ReactButton>
                             
                </div>
        </Row>
        <Row>
            <Column className='documate-recycle-bin-leftPanel'>
                <Panel>
                    <Row>
                        {renderNotes(docHistory)}
                    </Row>
                    <div className="notes-footer">
                        <Row style={{width:'97%',display:'flex'}}>
                            <Column lg={10} md={10} sm={10}>
                                <TextInput
                                    id="txtAddNote"
                                    type="text"
                                    size="sm"
                                    maxLength={250}
                                    value={newNote}
                                    onChange={(e) => {
                                        setNewNote(e.target.value);
                                        setNoteError(false); // Reset error on change
                                    }}
                                    placeholder="Add a note..."
                                        isInvalid={noteError}
                                        // tabIndex={lastTabIndex + 1}
                                />
                            </Column>
                            <Column lg={2} md={2} sm={2}>
                                <ReactButton
                                    className="btn btn-primary"
                                    size="small"
                                        onClick={handleAddNote}
                                        /*  tabIndex={lastTabIndex + 2}
                                        ref={lastButtonRef}
                                        onKeyDown={(e) => {
                                            if (e.key == "Tab" && !e.shiftKey) {
                                                firstControlRef.current.focus();
                                                e.preventDefault();
                                            }
                                        }}
                                        */
                                >
                                    {documateLabel.DOCUMATE_INDEXING_BUTTONS.submit}
                                </ReactButton>
                            </Column>
                        </Row>
                    </div>
                    </Panel>


            </Column>
            <Column className='documate-recycle-bin-rightPanel'>
                <div className="doc-view-container">
                    <DocViewer document={docPdf} scanId={docNameAPI} />
                    </div>

            </Column>
        </Row>
         {/* Confirm Modal */}
                    <ConfirmModal
                        modaltitle="Confirmation"
                        showConfirmation={showConfirmModal}
                        setConfirmation={(isModalOpen) => setShowConfirmModal(isModalOpen)}
                        body={modalBody}
                        closeButtonClick={() => {
                            setShowConfirmModal(false)
                        }} // Close the modal
                        successButtonClick={() => modalSuccess()}
                        closeButtonLabel="No"
                        successButtonLabel="Yes"
                    />
     </div>
 );
}

export default DocuMateRecycleBin;